import { Text } from '@kanda-libs/ks-design-library';

interface CardBodyTextProps {
  children: string;
  isLoading?: boolean;
}

const CardBodyText = ({ children, isLoading }: CardBodyTextProps) => (
  <Text
    isLoading={isLoading}
    className="block text-14-24-em text-neutral-600 mb-4 last:mb-0"
    text={children}
  />
);

export default CardBodyText;
